export const noop = () => {
  /* */
};

export const hexToRgba = (hex: string, alpha: number): string => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

/**
 * Convert a date string to a date object with the correct timezone offset.
 *
 * Given a date string in the format "yyyy-mm-dd", this function will return a
 * Date object with the correct timezone offset. If the date string is null or
 * undefined, the function will return null.
 *
 * @param dateString - the date string to be converted
 * @returns a Date object with the correct timezone offset, or null if the
 *          input string is null or undefined
 */
export const toGMTDate = (dateString: string | null): Date | null => {
  if (!dateString) {
    return null;
  }
  const date = new Date(dateString);
  return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
};
